//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from '~/services/apiClient'
import { exists, formatKB } from '~/utils/utils'
import { vLog } from '~/utils/vLog'
import VeeValidate from '~/mixins/veeValidate'
import VInput from '~/mixins/vInput'

const STATUS_INITIAL = 0
const STATUS_SAVING = 1
const STATUS_SUCCESS = 2
const STATUS_FAILED = 3

export default {
  name: 'File',
  mixins: [
    VeeValidate, VInput
  ],
  props: {
    title: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: 'fields'
    },
    placeholder: {
      type: String,
      default: ''
    },
    field: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'file'
    },
    value: {
      type: [String, Number],
      default: ''
    },
    isHidden: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    uploadFunc: {
      type: Function,
      default: (files) => {
        return axios.post('', files)
          .then(x => x.data)
      }
    },
    form: {
      type: Object,
      default: () => {}
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    isPreview: {
      type: Boolean,
      default: true
    },
    isPreviewText: {
      type: Boolean,
      default: false
    },
    disabledIfFilled: {
      type: Boolean,
      default: false
    },
    maxSize: {
      type: Number,
      default: 2048
    }
  },
  data () {
    return {
      model: null,
      uploadedFiles: [],
      uploadError: null,
      currentStatus: null,
      curType: this.type,
      input: {
        id: null
      }
    }
  },
  computed: {
    getErrors: {
      cache: false,
      get () {
        return this.$refs?.form?.errors
      }
    },
    hasErrors: {
      cache: false,
      get () {
        return !!(this.getErrors && this.getErrors[this.field ? this.field : this.name]?.length) ||
          exists(this.form?.errors?.get(this.field ? this.field : this.name))
      }
    },
    hasErrorText: {
      cache: false,
      get () {
        return (this.getErrors && this.getErrors[this.field ? this.field : this.name] && this.getErrors[this.field ? this.field : this.name] && this.getErrors[this.field ? this.field : this.name][0]) ||
          (this.form?.errors?.get(this.field ? this.field : this.name))
      }
    },
    getErrorText: {
      cache: false,
      get () {
        if (this.hasErrorText) {
          return (this.getErrors[this.field ? this.field : this.name][0]) || this.form?.errors?.get(this.field ? this.field : this.name)
        }
      }
    },
    isInitial () {
      return this.currentStatus === STATUS_INITIAL
    },
    isSaving () {
      return this.currentStatus === STATUS_SAVING
    },
    isSuccess () {
      return this.currentStatus === STATUS_SUCCESS
    },
    isFailed () {
      return this.currentStatus === STATUS_FAILED
    },
    getRules () {
      const result = []
      // if (this.maxSize) {
      //   result.push(`size:160000`)
      // }
      return result.join('|')
    }
  },
  watch: {
    '$refs.form.errors' () {
      console.log(this.$refs?.form?.errors)
    },
    'value' () {
      if (!this.value) {
        this.reset()
      }
    }
  },
  mounted () {
    this.input.id = this.getRandomInt()
    this.reset()
  },
  methods: {
    close () {
      this.input.isDrag = false
    },
    formatKB (bytes, decimals = 2) {
      return formatKB(bytes, decimals)
    },
    async onChange (e) {
      const isValid = await this.$refs.form.validate()
      if (!isValid) {
        this.currentStatus = STATUS_FAILED
        this.model = null
        return
      }
      const files = e.target.files || e.dataTransfer.files
      this.fileCount = files.length

      this.$emit('change', files)
      this.save(files, e)
    },
    reset () {
      // reset form to initial state
      this.model = null
      this.currentStatus = STATUS_INITIAL
      this.uploadedFiles = []
      this.uploadError = null
    },
    save (files, e = null) {
      // upload data to the server
      this.currentStatus = STATUS_SAVING
      if (!files.length) {
        this.currentStatus = STATUS_INITIAL
        return
      }
      try {
        this.uploadFunc(files, e)
          .then((x) => {
            this.uploadedFiles = [].concat(x)
            this.currentStatus = STATUS_SUCCESS
          })
          .catch((err) => {
            vLog(this, err)
            this.uploadError = err.response
            this.currentStatus = STATUS_FAILED
            this.model = null
          })
      } catch (e) {
        vLog(this, e)
        this.currentStatus = STATUS_FAILED
        this.model = null
      }
    },
    getRandomInt () {
      return Math.floor(Math.random() * 100000)
    }
  }
}
